import React, { useState, useEffect } from 'react';
import {
  Box,
  Input,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Tag,
  Flex,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
} from '@chakra-ui/react';
import axios from 'axios';

const IssuingAuthoritiesPool = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [newName, setNewName] = useState('');
  const [newId, setNewId] = useState('');
  const [newDescription, setNewDescription] = useState('');
  const [data, setData] = useState([]);
  const [selectedIssuingAuthority, setSelectedIssuingAuthority] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    fetchIssuingAuthorities();
  }, []);

  const fetchIssuingAuthorities = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/admin/get-issuing-authorities`,{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      setData(response.data.data);
    } catch (error) {
      console.error('Error fetching issuing authorities:', error);
    }
  };

  const handleAdd = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      const newIssuingAuthority = { name: newName, issuingAuthorityId: newId, description: newDescription };
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/admin/add-issuing-authority`, newIssuingAuthority,{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      fetchIssuingAuthorities();
      setNewName('');
      setNewId('');
      setNewDescription('');
      onClose();
    } catch (error) {
      console.error('Error adding issuing authority:', error);
    }
  };

  const handleUpdate = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      await axios.put(`${process.env.REACT_APP_SERVER_URL}/admin/update-issuing-authority/${selectedIssuingAuthority._id}`, selectedIssuingAuthority,{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      fetchIssuingAuthorities();
      onClose();
    } catch (error) {
      console.error('Error updating issuing authority:', error);
    }
  };

  const handleEdit = (issuingAuthority) => {
    setSelectedIssuingAuthority(issuingAuthority);
    onOpen();
  };

  const filteredData = data.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box p={4}>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <Heading>Issuing Authorities Pool</Heading>
        <Button colorScheme="teal" onClick={onOpen}  position="absolute" top="10px" right="10px" zIndex="1000">
          Add
        </Button>
      </Flex>

      <Input
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        mb={4}
      />

      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>ID</Th>
            <Th>Description</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {filteredData.map((item, index) => (
            <Tr key={index}>
              <Td>
                <Tag>{item.name}</Tag>
              </Td>
              <Td>{item.issuingAuthorityId}</Td>
              <Td>{item.description}</Td>
              <Td>
                <Button size="sm" colorScheme="blue" onClick={() => handleEdit(item)}>
                  Edit
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{selectedIssuingAuthority ? 'Edit Issuing Authority' : 'Add New Issuing Authority'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input
                placeholder="Name"
                value={selectedIssuingAuthority ? selectedIssuingAuthority.name : newName}
                onChange={(e) => selectedIssuingAuthority ? setSelectedIssuingAuthority({ ...selectedIssuingAuthority, name: e.target.value }) : setNewName(e.target.value)}
                mb={2}
              />
            </FormControl>
            <FormControl>
              <FormLabel>ID</FormLabel>
              <Input
                placeholder="ID"
                value={selectedIssuingAuthority ? selectedIssuingAuthority.issuingAuthorityId : newId}
                onChange={(e) => selectedIssuingAuthority ? setSelectedIssuingAuthority({ ...selectedIssuingAuthority, issuingAuthorityId: e.target.value }) : setNewId(e.target.value)}
                mb={2}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Description</FormLabel>
              <Input
                placeholder="Description"
                value={selectedIssuingAuthority ? selectedIssuingAuthority.description : newDescription}
                onChange={(e) => selectedIssuingAuthority ? setSelectedIssuingAuthority({ ...selectedIssuingAuthority, description: e.target.value }) : setNewDescription(e.target.value)}
                mb={2}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={selectedIssuingAuthority ? handleUpdate : handleAdd}>
              {selectedIssuingAuthority ? 'Update' : 'Submit'}
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default IssuingAuthoritiesPool;